import { ConversionListFormType, IngredientType } from 'models/pricing.model';

export const initializeMealTypeMap = (
  items: IngredientType[] | undefined
): Record<string, string> => {
  if (!items || items.length === 0) {
    return {};
  }

  const mealTypeMap: Record<string, string> = {};

  items.forEach((item, index) => {
    if (item.type === 'mix') {
      mealTypeMap[index] = 'mix';
    } else if (item.type === 'ingredient' || item.type === 'prep') {
      mealTypeMap[index] = 'ingredients';
    }
  });

  return mealTypeMap;
};

export const validateStep1 = (conversionListFormData: ConversionListFormType[]): boolean => {
  if (!conversionListFormData || conversionListFormData.length === 0) {
    return false;
  }

  return conversionListFormData.every((item) => {
    const hasBrand = item.secton_name && item.secton_name.trim().length > 0;
    const hasName = item.name && item.name.trim().length > 0;
    return hasBrand && hasName;
  });
};

export const validateStep2 = (conversionListFormData: ConversionListFormType[]): boolean => {
  if (!conversionListFormData || conversionListFormData.length === 0) {
    return false;
  }

  const isValidPositiveNumber = (value: unknown): boolean => {
    if (value === null || value === undefined) return false;
    const num = Number(value);
    return Number.isFinite(num) && num > 0;
  };

  const getIngredientName = (ing: any): string => {
    return String(ing?.ingredient_name ?? ing?.name ?? '').trim();
  };

  return conversionListFormData.every((item) => {
    const hasPortions = item.no_of_portions && Number(item.no_of_portions) > 0;
    const hasPortionType = item.portion_type && item.portion_type.trim().length > 0;

    const allIngredientRowsValid = (item.ingredients ?? []).every((ing: any) => {
      const ingredientName = getIngredientName(ing);
      const hasIngredient = ingredientName.length > 0;

      if (!hasIngredient && !isValidPositiveNumber(ing?.quantity)) return true;

      if (hasIngredient) return isValidPositiveNumber(ing?.quantity);

      return false;
    });

    const allPackagingRowsValid = (item.packaging ?? []).every((pkg: any) => {
      const ingredientName = getIngredientName(pkg);
      const hasIngredient = ingredientName.length > 0;

      // if (!hasIngredient && !isValidPositiveNumber(pkg?.quantity)) return true;
      if (hasIngredient) return isValidPositiveNumber(pkg?.quantity);
      return false;
    });

    const hasAtLeastOneValidIngredient = (item.ingredients ?? []).some((ing: any) => {
      const ingredientName = getIngredientName(ing);
      return ingredientName.length > 0 && isValidPositiveNumber(ing?.quantity);
    });

    return (
      hasPortions &&
      hasPortionType &&
      hasAtLeastOneValidIngredient &&
      allIngredientRowsValid &&
      allPackagingRowsValid
    );
  });
};

export const createConversionPayload = (
  conversionListFormData: ConversionListFormType[],
  isPrepConfig: boolean
) => {
  const data = {
    items:
      conversionListFormData?.map((ingredientMix) => {
        return {
          name: ingredientMix?.name ?? '',
          secton_name: ingredientMix?.secton_name ?? ingredientMix?.brand ?? '',
          no_of_portions: Number(ingredientMix?.no_of_portions ?? 0),
          portion_type: ingredientMix?.portion_type ?? '',
          ingredients: [
            ...(ingredientMix?.ingredients
              ?.map((ing) => {
                return {
                  ingredient_id: ing.ingredient?.id ?? ing?.id ?? '',
                  quantity: Number(ing.quantity ?? 0)
                };
              })
              .filter((ing) => ing.ingredient_id && ing.quantity > 0) ?? []),
            ...(ingredientMix?.packaging
              ?.map((_) => {
                return {
                  ingredient_id: _.ingredient?.id ?? '',
                  quantity: Number(_.quantity ?? 0)
                };
              })
              .filter((pkg) => pkg.ingredient_id && pkg.quantity > 0) ?? [])
          ]
        };
      }) ?? [],
    type: !isPrepConfig ? 'meal' : 'prep'
  };

  return data;
};
